import { GitHub, InfoOutlined } from "@mui/icons-material";
import { Box, Button, Chip, Link, Paper, Stack, Typography } from "@mui/material";

export default function EditorHeader({ accentColor, onInfoOpen }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2.25, sm: 3.5 },
        borderRadius: { xs: 3, sm: 4 },
        border: (theme) => `1px solid ${theme.palette.outline?.main}`,
        background: (theme) =>
          `linear-gradient(135deg, ${theme.palette.surface?.elevated} 0%, ${theme.palette.background.paper} 100%)`,
      }}
    >
      <Stack spacing={2.5}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          spacing={2}
          alignItems={{ xs: "flex-start", md: "center" }}
        >
          <Box>
            <Chip
              label="Project Sekai Sticker Editor"
              sx={{
                mb: 1.25,
                color: "text.primary",
                backgroundColor: (theme) => theme.palette.tonal?.soft,
                borderColor: (theme) => theme.palette.outline?.accent,
              }}
              variant="outlined"
            />
            <Typography
              variant="h2"
              sx={{
                fontFamily: "YurukaStd, sans-serif",
                fontSize: { xs: "2.1rem", sm: "3rem", md: "3.5rem" },
                lineHeight: 1,
                letterSpacing: "-0.02em",
              }}
            >
              Project Sekai Stickers Maker
            </Typography>
          </Box>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.25}>
            <Button
              variant="outlined"
              startIcon={<InfoOutlined />}
              onClick={onInfoOpen}
              sx={{ color: "text.primary" }}
            >
              About / 关于
            </Button>
            <Button
              variant="contained"
              startIcon={<GitHub />}
              href="https://github.com/KurisuRakko/sekai-stickers"
              target="_blank"
              rel="noreferrer"
              sx={(theme) => ({
                backgroundColor: accentColor,
                color: theme.palette.getContrastText(accentColor),
                "&:hover": {
                  backgroundColor: accentColor,
                },
              })}
            >
              Star on GitHub
            </Button>
          </Stack>
        </Stack>

        <Stack spacing={1}>
          <Typography variant="body1" color="text.secondary">
            Create playful Project Sekai stickers with a calmer MD2 editing flow.
            保留原本的贴纸生成方式，但把预览、参数和导出整理得更顺手。
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Maintained by{" "}
            <Link
              href="#"
              onClick={(event) => {
                event.preventDefault();
                onInfoOpen();
              }}
              sx={{ color: accentColor }}
            >
              KurisuRakko
            </Link>
            .
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
}
